import CombinedViolationsFinesBreakdown from './CombinedViolationsFinesBreakdown/CombinedViolationsFinesBreakdown'
import SingleViolationFinesBreakdown from './SingleViolationFinesBreakdown/SingleViolationFinesBreakdown'

export default {
  CombinedViolationsFinesBreakdown,
  SingleViolationFinesBreakdown,
}
